import React, { useEffect, useState } from 'react'
import { Col, Row, Tab, Tabs } from 'react-bootstrap'
import { Container } from 'react-bootstrap';
import { FormControl, InputLabel, MenuItem, Pagination, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCoursesAction } from '../redux/actions/courseAction';
import { FiShare2 } from 'react-icons/fi';
import Share from '../helper/sharer/Share';
import { getPatnerCourses } from '../redux/actions/ActiveCourseAction';
import MobilizationDashboard from './Dashboard/MobilizationDashboard';
import ShgDashboard from './Dashboard/ShgDashboard';
import TrainingDashboard from './Dashboard/TrainingDashboard';
import EnterpriseDashboard from './Dashboard/EnterpriseDashboard';


const Dashboard = () => {
    return (
        <>
            {<MobilizationDashboard />}
            <hr />
            {<ShgDashboard />}
            <hr />
            {<TrainingDashboard />}
            <hr />
            {<EnterpriseDashboard />}
        </>
    )
}

export default Dashboard